import { useIntl } from 'react-intl'
import styled from 'styled-components'
// oxlint-disable-next-line no-restricted-imports - Campaign artwork uses fixed coral/black colours across product palettes.
import { BLACK, CORAL } from 'constants/themes/primitiveColours'
import { slugify } from 'lib/string/stringUtils'
import HighlightLabel from 'LuxKit/Label/HighlightLabel'

export const MALDIVES_BONUS_INCLUSIONS_CAMPAIGN_TAG_SLUG = 'maldives_bonus_inclusions'

export function hasMaldivesBonusInclusionsCampaignTag(tags: ReadonlyArray<string>): boolean {
  return tags.some(tag => slugify(tag) === MALDIVES_BONUS_INCLUSIONS_CAMPAIGN_TAG_SLUG)
}

const CampaignLabel = styled(HighlightLabel)`
  && {
    background-color: ${CORAL[300]};
    border-color: ${CORAL[300]};
    color: ${BLACK[900]};
    border-radius: 2px;
  }
`

function MaldivesBonusInclusionsCampaignLabel() {
  const intl = useIntl()

  return <CampaignLabel>
    {intl.formatMessage({
      id: 'iRWywFdCtJ8vAhSPvkBJ',
      defaultMessage: 'Limited-Time Bonus Inclusion',
      description: 'Green campaign badge shown on offers tagged Maldives Bonus Inclusions in admin',
    })}
  </CampaignLabel>
}

export default MaldivesBonusInclusionsCampaignLabel
